import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classNames from 'classnames';
import classes from './ExpandableListItemA.module.scss';

const ExpandableListItemA = (props) => {
  const {
    title,
    body,
    onClick,
    showBody,
  } = props;

  if (!title || !body) {
    return null;
  }

  return (
    <div className={classes.container}>
      <button aria-label='Toggle' className={classes.toggle} onClick={onClick} type='button'>
        <div className={classes.iconWrapper}>
          <FontIcon
            className={classes.icon}
            icon={showBody ? 'far fa-minus-circle' : 'far fa-plus-circle'}
          />
        </div>
        <div
          className={classes.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </button>
      <div
        className={classNames(classes.body, showBody ? '' : classes.hide)}
        dangerouslySetInnerHTML={{ __html: body }}
      />
    </div>
  );
};

ExpandableListItemA.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  onClick: PropTypes.func,
  showBody: PropTypes.bool,
};

export default ExpandableListItemA;
